    <div class="profile">
        <div class="mb-0">
            <div class="card-body profile__container">
                <div class="row">
                    <div class="col-3">
                        <img src="assets/images/avatarsys2024.png" class="profile__image" alt="foto de perfil"/>
                    </div>
                    <div class="col-8">
                        <h4 class="profile__welcome">Bienvenido</h4>
                        <h4 class="profile__name">{{InfoPersonal[0].PAD10NOM}} </h4>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="card-body profile__body">
                <table style="width: 100%" >
                    <tr>
                        <td><strong>Nombre: </strong><span> {{InfoPersonal[0].PAD10NOM}} </span> </td>
                        <td><strong>Tel&eacute;fono: </strong><span>{{InfoPersonal[0].TELEFONO}}</span></td>
                    </tr>
                    <tr>
                        <td><strong>Cédula: </strong><span>{{InfoPersonal[0].CEDULA}}</span></td>
                        <td><strong>Correo: </strong><span>{{InfoPersonal[0].CORREO}}</span></td>
                    </tr>
                    <tr style="text-align: right">
                        <td colspan="2">
                            <button class="btn btn-sm btn-fondo " (click)="abrirPerfil()">
                                Perfil completo
                            </button>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>